import { styled } from '@mui/material/styles'
import { tooltipClasses, TooltipProps } from '@mui/material/Tooltip'
import { Tooltip } from '@mui/material'
import theme from 'theme'

export const AddIconTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    borderRadius: theme.attributes.borderRadius.tertiary,
    background: theme.colors.tooltipBg,
    boxShadow: '0px 4px 8px 0px rgba(30, 26, 29, 0.20)',
    display: 'flex',
    gap: `${theme.spacing.xSmall}px`,
    padding: `${theme.spacing.md}px`,
    width: 'fit-content',
    minHeight: '41px',

    "html[data-theme='light'] &": {
      background: '#f8e7f2'
    }
  },
  '.tooltip-text': {
    color: theme.colors.menuItemText,
    fontFamily: theme.typography.fontFamily.primary,
    fontSize: theme.typography.fontSize.medium,
    fontStyle: 'normal',
    fontWeight: theme.typography.fontWeight.extraThick,
    lineHeight: '140%',
    wordBreak: 'break-word'
  },

  '.error-wrapper-instance': {
    width: '210px !important',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',

    '.tooltip-text': {
      color: theme.colors.menuItemText,
      fontFamily: theme.typography.fontFamily.primary,
      fontSize: theme.typography.fontSize.medium,
      fontStyle: 'normal',
      fontWeight: theme.typography.fontWeight.extraThick,
      lineHeight: '140%',
      wordBreak: 'break-word'
    },
    '.tooltip-description': {
      color: theme.colors.devicesSecondaryText,
      fontFamily: 'Quicksand',
      fontSize: '10px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '140%',
      wordBreak: 'break-word'
    }
  }
})
